import React from 'react';
import PropTypes from 'prop-types';
import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify(window);
export const { sanitize } = DOMPurify;

function Sanitize(props) {
  const { className, children } = props;
  return <span className={className}>{sanitize(children)}</span>;
}

Sanitize.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

export default Sanitize;
